module.exports = __webpack_public_path__ + "static/media/abhishekgiri.84ff8389.jpg";